import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TableColumnStateService {
  static setData(
    pageName: string,
    columnName: string,
    propName: 'size' | 'order' | 'isHide',
    value: string | number | boolean
  ) {
    const storedData = localStorage.getItem('table_config');

    let tableStateData = storedData ? JSON.parse(storedData) : {};

    if (!tableStateData[pageName]) tableStateData[pageName] = {};

    if (!tableStateData[pageName][columnName])
      tableStateData[pageName][columnName] = {};

    tableStateData[pageName][columnName][propName] = value;

    localStorage.setItem('table_config', JSON.stringify(tableStateData));
  }

  static getData(pageName: string) {
    const storedData = localStorage.getItem('table_config');
    if (!storedData) return null;
    const tableStateData = JSON.parse(storedData);

    if (tableStateData[pageName] && tableStateData[pageName])
      return tableStateData[pageName];

    return null;
  }

  static resetData(pageName: string): any {
    const storedData = localStorage.getItem('table_config');
    if (storedData) {
      const tableStateData = JSON.parse(storedData);
      if (tableStateData[pageName]) {
        delete tableStateData[pageName];
        localStorage.setItem('table_config', JSON.stringify(tableStateData));
      }
    }
  }
}
